<template>
    <form @submit="submitForm" novalidate="true">
        <v-card>
            <v-card-title>
                <span class="headline">{{editMode ? 'Редагування' : 'Додавання'}}</span>
            </v-card-title>
            
            <v-card-text>
                <v-container grid-list-md>
                    <v-layout v-if="!loading" wrap>
                        <v-flex xs12>
                            <v-text-field :error-messages="errors.name" v-model="form.name"
                                          label="Назва"></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-select
                                    :items="semesters"
                                    v-model="form.semester"
                                    :error-messages="errors.semester"
                                    item-text="name"
                                    item-value="id"
                                    return-object
                                    label="Семестр"
                                    filled
                            ></v-select>
                        </v-flex>

                        <v-flex xs12>
                            <v-select
                                    :items="specialities"
                                    v-model="form.speciality"
                                    :error-messages="errors.speciality"
                                    item-text="name"
                                    item-value="id"
                                    return-object
                                    label="Спеціальність"
                                    filled
                            ></v-select>
                        </v-flex>

                        <div class="title">Профілі</div>
                        <v-flex xs12 md12 :key="index" v-for="(profile, index) in form.profiles">
                            <v-layout>
                                <v-flex xs8>
                                    <v-autocomplete
                                            :items="profiles"
                                            v-model="form.profiles[index]"
                                            item-text="name"
                                            item-value="id"
                                            return-object
                                            label="Профіль"
                                    ></v-autocomplete>
                                </v-flex>
                                <v-flex xs3>
                                    <v-text-field
                                            :error-messages="getError(index, 'percentage')"
                                            @keypress="isNumber($event, 2)"
                                            v-model="form.profiles[index].percentage" 
                                            label="%"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex>
                                    <v-btn @click="removeProfile(index)" color="red" dark>
                                        <v-icon>clear</v-icon>
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex xs12>
                            <div v-if="errors.profiles !== undefined && 
                                errors.profiles.length !== 0" class="red--text">{{errors.profiles}}</div>
                        </v-flex>
                        <v-btn @click="addProfile()">Додати профіль</v-btn>
                    </v-layout>
                    <loading-placeholder v-else></loading-placeholder>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                        color="primary"
                        @click.native="$emit('shouldCloseAddEdit')"
                        :disabled="loadingSave"
                >Відміна
                </v-btn>
                <v-btn
                        text
                        type="submit"
                        :loading="loadingSave"
                        :disabled="loadingSave"
                >Зберегти
                </v-btn>
            </v-card-actions>
        </v-card>
    </form>
</template>

<script>
    import HttpService from "../../../../HttpService";
    import {remapErrors} from "../../../../helpers/errorsHelper";
    import LoadingPlaceholder from "../../../common/LoadingPlaceholder";
    import {isNumber} from "../../../../helpers/numberHelper";
    

    export default {
        props: {
            editId: Number,
            editMode: Boolean,
        },
        components: {
            loadingPlaceholder: LoadingPlaceholder,
        },
        data: () => {
            return {
                form: {
                    name: null,
                    profiles: [{}],
                    semester: null,
                    speciality: null,
                },
                errors: {
                    name: [],
                    profiles: [],
                    semester: [],
                    speciality: [],
                },
                profiles: [],
                semesters: [],
                specialities: [],
                loading: false,
                loadingSave: false,
                isNumber: isNumber,
            }
        },
        mounted() {
            HttpService.getInstance()
                .get("stepProfile/getAll")
                .then(resp => {
                    this.profiles = resp;
                });

            HttpService.getInstance()
                .get("navigation/getSemesters")
                .then(resp => {
                    this.semesters = resp.map(sem => {
                        sem.name = `${sem.yearNumber} курс (${sem.semesterNumber} семестр)`;
                        return sem;
                    });
                });

            HttpService.getInstance()
                .get("navigation/getSpecialities")
                .then(resp => {
                    this.specialities = resp.map(spec => {
                        spec.name = spec.nameUk;
                        
                        return spec;
                    });
                });

            if (this.editMode) {
                this.loading = true;

                HttpService.getInstance()
                    .get(`stepKrok/${this.editId}`)
                    .then(resp => {
                        this.loading = false;
                        this.form = resp;
                    })
            }
        },
        methods: {
            getError(index, field) {
                const formIndex = this.errors[`subjects[${index}]`];
                if (formIndex === undefined) {
                    return [];
                }
                
                if (formIndex[field] !== undefined) {
                    return formIndex[field];
                }
                
                return [];
            },
            removeProfile(index) {
              this.form.profiles.splice(index, 1);  
            },
            addProfile() {
                this.form.profiles.push({percentage: 0});                
            },
            submitForm(e) {
                e.preventDefault();

                this.loadingSave = true;

                HttpService.getInstance()
                    .post("stepKrok", this.form)
                    .then(resp => {
                        this.loadingSave = false;
                        this.$emit("addedEdited");
                    })
                    .catch(err => {
                        this.loadingSave = false;
                        if (err.errors) {
                            this.errors = remapErrors(err.errors);
                        }
                    });
            },
        }
    }
</script>